import config from 'config'

// eslint-disable-next-line import/prefer-default-export
export const getCtaUrl = ({ embeddedWidgetQueryParams, showRateTableAsFirstPrequalStep }) => {
  const embeddedPrequalUrl = `${config.credibleRoot}/personal-loans/embedded-borrower/step/amount?${embeddedWidgetQueryParams}`
  const prequalUrl = `${config.credibleRoot}/personal-loans/borrower?${embeddedWidgetQueryParams}`

  return showRateTableAsFirstPrequalStep ? embeddedPrequalUrl : prequalUrl
}
